module.exports = __webpack_public_path__ + "Flag-578.c8c51920fb31b60e13bee954aaf29242.svg";